<template>
    <modal @close="$emit('close')" :autoshow="true" ref="modal" :is-closeable="isCloseable">
        <template v-slot:title>Terminate Employee</template>

        <template v-slot:subheading>
            <div class="p-1 unpad-x bg-150 rounded">
                <div><span class="text-muted">Employee:</span> {{ employee.full_name }}</div>
                <div><span class="text-muted">Company:</span> {{ employee.company.name }}</div>
            </div>
        </template>

        <slot>
            <div>
                <form>
                    <form-errors :errors="formErrors"/>

                    <div class="form-row">
                        <div class="col-10">
                            <form-input label="Termination Date" v-model="formData.date_terminated" :errors="errors.date_terminated" type="date" />
                        </div>
                    </div>
                    <div class="form-row mb-2">
                        <div class="col-10">
                            <form-input label="Eligible for Rehire" type="checkbox" v-model="formData.eligible_for_rehire" :errors="errors.eligible_for_rehire"/>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-10">
                            <form-input label="Termination Reason" type="select" :options="terminationReasonOptions" v-model="formData.termination_reason" :errors="errors.termination_reason"/>
                        </div>
                    </div>
                </form>
            </div>
        </slot>

        <template v-slot:footer>
            <div class="form-row">
                <div class="col">
                    <button type="button" class="btn btn-block btn-outline-primary" @click.prevent="close()">Cancel</button>
                </div>
                <div class="col">
                    <button type="submit" class="btn btn-block btn-primary" @click.prevent="onSubmit">Terminate Employee</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import moment from 'moment'

import ModalMixin from '@/mixins/ModalMixin'
import FormMixin from '@/mixins/Form'

export default {
    mixins: [ModalMixin, FormMixin],
    components: {},
    props: ['client', 'employee', ],
    data() {
        return {
            formData: this.makeFormData(),
            terminationReasonOptions: this.client.termination_reasons.map(r => ({text: r, value: r}))
        }
    },
    methods: {
        makeFormData() {
            return {
                date_terminated: moment().format('MM/DD/YYYY'), // default to today
                eligible_for_rehire: true,
                termination_reason: "",
            }
        },
        onSubmit() {
            this.errors = {}
            this.formErrors = []
            this.$api.post(`/clients/${this.client.id}/employees/${this.employee.id}/terminate`, this.getFormData()).then(resp => {
                this.$emit('updated')
                this.close()
            }).catch(errors => {
                this.errors = errors
                this.formErrors = errors.__all__
            })
        },
    }
}
</script>
